<template>
  <div class="tuolele-main-box">
    <div class="app-container app-margin-bottom20">
      <el-form ref="postForm" label-width="100px" style="width:45%" :model="tyyLive" :rules="rules">
        <el-form-item label="*直播主题" prop="live_title">
          <el-input v-model="tyyLive.live_title" placeholder="请输入直播主题" />
        </el-form-item>
        <el-form-item label="*直播日期" prop="live_date">
          <el-date-picker v-model="tyyLive.live_date" value-format="yyyy-MM-dd" type="date" placeholder="选择开始日期" />
        </el-form-item>
        <el-form-item label="*开始时间" prop="live_date">
          <el-time-select
            v-model="tyyLive.start_time"
            :picker-options="{
              start: '08:00',
              step: '00:30',
              end: '21:00'
            }"
            placeholder="选择时间"
          />
          <span>至</span>
          <el-time-select
            v-model="tyyLive.end_time"
            :picker-options="{
              start: '08:00',
              step: '00:30',
              end: '21:00'
            }"
            placeholder="选择时间"
          />
        </el-form-item>
        <el-form-item label="*适用科目" prop="subject_id">
          <Select key="5" :selected.sync="tyyLive.subject_id" :data="subjectLists" clearable placeholder="请选择" />
        </el-form-item>
        <el-form-item label="*适用年级" prop="grade_id">
          <Select key="66" :selected.sync="tyyLive.grade_id" :data="gradeLists" clearable placeholder="请选择" />
        </el-form-item>
        <el-form-item label="*教材版本" prop="teaching_type">
          <text-book-select :subject-id="tyyLive.subject_id" :selected.sync="tyyLive.teaching_type" />
        </el-form-item>
        <el-form-item label="*直播URL" prop="live_url">
          <el-input v-model="tyyLive.live_url" placeholder="请输入小鹅通中直播小程序链接" />
        </el-form-item>
        <!-- <h1 style="color:#666666;padding-left: 7px;margin-bottom: 10px;">退款信息</h1>
        <el-form-item label="*是否可退">
          <el-radio v-model="tyyLive.is_back" label="1">可退</el-radio>
          <el-radio v-model="tyyLive.is_back" label="2">不可退</el-radio>
        </el-form-item> -->
        <el-button type="primary" @click="fnSubmitForm">提交</el-button>
      </el-form>
    </div>

  </div>
</template>

<script>

import Select from '@/components/Select'
import TextBookSelect from '@/components/Select/TextBookSelect'
import { validateRequire } from '@/utils/validate'
import commondata from '@/utils/commondata'

// import TeachingTypeSelect from '@/components/Select/TeachingTypeSelect'

export default {
  components: {
    Select,
    TextBookSelect
  },
  data() {
    return {
      tyyLive: {
        live_title: '',
        subject_id: '',
        grade_id: '',
        live_date: '',
        live_url: '',
        teaching_type: '',
        start_time: '',
        end_time: '',
        live_id: ''
        // is_back: ''
      },
      gradeCheckLists: [],
      subjectLists: commondata.TYY_SUBJECT_LISTS,
      packageTypes: commondata.TYY_PACKAGE_TYPE,
      gradeLists: commondata.GRADE_LISTS,

      rules: {
        live_title: [{ validator: validateRequire, trigger: 'manual', message: '直播主题' }],
        subject_id: [{ validator: validateRequire, trigger: 'manual', message: '适用科目' }],
        grade_id: [{ validator: validateRequire, trigger: 'manual', message: '适用年级' }],
        live_date: [{ validator: validateRequire, trigger: 'manual', message: '直播日期' }],
        live_url: [{ validator: validateRequire, trigger: 'manual', message: '直播地址' }],
        teaching_type: [{ validator: validateRequire, trigger: 'manual', message: '教材版本' }],
        start_time: [{ validator: validateRequire, trigger: 'manual', message: '开始时间' }],
        end_time: [{ validator: validateRequire, trigger: 'manual', message: '结束时间' }]
      }
    }
  },
  watch: {
    gradeCheckLists(newVal, oldVal) {
      this.tyyLive.grade_id = (newVal || []).join(',')
    }
  },
  created() {
    this.tyyLive.live_id = this.$route.query.id || ''
    if (this.tyyLive.live_id) {
      this.fnGetLive()
    }
  },
  methods: {
    // 提交
    fnSubmitForm: function() {
      this.$refs.postForm.validate(valid => {
        if (valid) {
          this.$http.tyyEditLive(this.tyyLive).then(res => {
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
            setTimeout(this.$router.push({ path: '/admin/tiyouyou/tyyLiveSettingLists' }), 2000)
          })
        }
      })
    },
    fnGetLive: function() {
      this.$http.tyyGetLiveRow(this.tyyLive).then(res => {
        this.tyyLive = Object.assign(this.tyyLive, res.data)
        this.$nextTick(function() {
          this.tyyLive.teaching_type = parseInt(res.data.teaching_type || '')
        })
      })
    }

  }
}
</script>

<style lang="scss" >

</style>
